<!-- 联盟成员 -->
<template>
    <!-- <div class=''>联盟成员</div> -->
     <div class="container">
      <banner></banner>
     <div  class="content">
      <div  class="content_left">
        
        <div class="left_item" @click="godetail(item.id)" v-for="(item, index) in companyList" :key="index">
          <img :src="item.avatar" style="padding: 16px;"  width="160px" height="100px" alt="">
          <div style="display: flex;   flex-direction: column;">
          <h2 style="padding: 8px 0 0 0; font-size: 18px; height: 30px;">{{ item.name }}</h2>
          <div class="content_detail" style="position: relative; display: flex;" >
        
         <p style="color: darkgrey">{{ item.country }}</p>
         <!-- <p style="color: darkgrey">CFFEX</p> -->
        
         <p class="button-text">监管中</p>
         <div class="content_described ">
          <span style="border: 1px solid darkgrey;
          padding: 2px 2px;
           border-radius: 2px; ">{{ item.short_name
 }}</span>
             <span class="detail-tag" style=" color: darkgrey;border: 1px solid darkgrey;margin-left: 8px ;
           border-radius: 2px; ">{{ item.tag_1 }}</span>
           <p style="font-size: 12px; width: 660px; padding: 4px  0 0 0;">{{ item.introduction?.slice(0, 80) + (item.introduction?.length > 30 ? '...' : '') }}</p>
         </div>
         
        </div></div>
        <div class="version">
        <span class="version_text" ><h2 style="font-size: 30px;">{{ item.score}}</h2></span>
        </div>
        </div>
      
      </div>
      <div  class="content_right">
        <h2 style="padding: 16px 0 0 16px; font-size: 18px; height: 30px;">精选资管</h2>
        <div class="right_item" @click="godetail(item.id)" v-for="(item, index) in scoreList" :key="index">
          <span>
          <img :src="item.avatar"  style="padding:  0 0 0 16px;" width="160px" height="80px" /></span>
          <div class="content_detail_2">
          <h2 style="padding: 0 0 0 14px; font-size: 18px; " >{{formatName(item.name) }}</h2>
          <div class="score-row">
            <h2 class="score-value">{{ item.score }}</h2>
            <p class="score-label">xxx评分</p>
          </div>
          <div class="content_detail_row">
            <span class="detail-tag">{{ item.country }}</span>
            <span class="detail-tag">{{ formatIntro(item.introduction) }}</span>
          </div>
        </div>
        </div>
      
      </div>
     </div>
    </div>
    </template>
    
    <script>
   import { getCompanyList,getCompanyDetail } from '@/api/api'
   import banner from '@/views/layout/components/banner.vue'
    export default {
      components: {banner}, 
      data  () {
        return { enterAngle: 0, // 用来存储鼠标进入时的角度
          companyList: [],
          scoreList:[]
        }
      },
      computed: {},
      watch: {
        
      },
      methods: {
   
        godetail(id){
          this.$router.push({ path: '/memberDetail', query: { id: id } })
        },
        async getInfo() {
          try {
            const res = await getCompanyList()
            this.companyList = res
            console.log("公司列表：", this.companyList)
            // 获取数据后立即调用 getscoreList
            this.getscoreList()
          } catch (error) {
            console.error('获取公司列表失败：', error)
          }
        },
        getscoreList() {
          // 清空数组
          this.scoreList = []
          
          // 确保 companyList 存在且是数组
          if (Array.isArray(this.companyList)) {
            this.companyList.forEach(item => {
              if (item.score >= 8) {
                this.scoreList.push(item)
              }
            })
            console.log("精选资管列表：", this.scoreList)
          } else {
            console.warn("companyList 不是数组或为空")
          }
        },
        formatName(name) {
          if (!name) return '';
          return name.length > 12 ? name.slice(0, 20) + '...' : name;
        },
        formatIntro(intro) {
          if (!intro) return '';
          return intro.length > 10 ? intro.slice(0, 50) + '...' : intro;
        }
    },
      created  () {
    
      },
      mounted  () {
        this.getInfo()
        
        
      
      },
    }
    </script>
    <style lang='scss' scoped>

 .app-container {
  background-color: rgba(248, 247, 251, 1);
  min-height: 100vh;
  display: flex; // or block, depending on your layout needs
  flex-direction: column; // if using flex
}
    .content{
      width: 100%;
      display: flex;
     background-color: rgba(248, 247, 251, 1);
      margin: auto;
      margin-top: 16px;
      align-items: flex-start; 
    
    }
    .content_left{
      width: 64%;
      justify-content:space-between;
      overflow-y: auto;
      height: 800px;
    }
    .left_item{
      margin-bottom: 10px;
      background-color: #ffffff;
      display: flex;
      border-radius: 8px;
      transition: all 0.3s ease;
      cursor: pointer;
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-8px);
      }
    }
    .content_detail p{
      font-size: 12px;
      padding:0px 4px 0 4px ;
      margin-top: 4px;
      font-family: Alibaba PuHuiTi 2.0, Alibaba PuHuiTi 20;
    }
    .content_described{
      margin-top: 34px;
      position: absolute;
     margin-left: -1px;
     color: darkgrey;
     font-size: 10px
    }
    .button-text {
  display: inline-block; /* Makes the h2 behave like a block-level element */
  background-color: #b3d9ff; /* Light blue background */
  border: 1px solid #b3d9ff; /* A border to give it a button-like edge */
  border-radius: 2px; /* Rounded corners */
  text-align: center; /* Center the text */
  text-decoration: none; /* Remove any text underline */
 color:deepskyblue; /* Dark blue text color */
  font-size: 14px; /* Adjust font size as needed */
  font-weight: bold; /* Bold text for emphasis */
  cursor: pointer; /* Cursor changes to a pointer when hovering */
  transition: background-color 0.3s; /* Smooth transition for hover effect */
}
.version{
  background-color:dodgerblue; /* 背景颜色 */
    height: 8px;
    text-align: center;
    line-height: 50px; /* 使文字居中 */
    font-size: 24px; /* 文字大小 */
    font-weight: bold; /* 文字加粗 */
  margin-left: auto; 
  width: 68px;
  margin-top: 60px;
  margin-right: 30px;
  
}
.version_text{
  position: relative;
    top: -34px; /* 文字向上移动 */
    color: black; /* 文字颜色 */
}
    .content_right{
      width: 34%;
      height: 100%;
      background-color: #ffffff;
      margin-left: auto;
      border-radius: 4px 4px 4px 4px;
      overflow-y: auto;
      height: 500px;
    }
    .right_item{
      display: flex;
      margin-top: 7px;
      margin-bottom: 16px;
      transition: all 0.3s ease;
      cursor: pointer;
      
      &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }
    }
    .content_detail_2{
      display: flex;
      flex-direction: column;
    }
    .version_text_2{
      display: flex;
      flex-direction: row; /* 横向排列 */
      
    }
    .content_detail_row span {
      display: inline-block;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .score-row {
      display: flex;
      align-items: center;
      padding: 6px 0 0 14px;
      
      .score-value {
        font-size: 20px;
        color: dodgerblue;
        margin-right: 5px;
      }
      
      .score-label {
        padding: 8px 0 0 5px;
        color: darkgrey;
        font-size: 12px;
      }
    }

    .content_detail_row {
      flex-direction: row;
      margin-top: 2px;
      text-align: center;
      margin-left: 14px;
      display: flex;
      align-items: center;
    }

    .detail-tag {
      color: darkgrey;
      border: 1px solid darkgrey;
      font-size: 10px;
      border-radius: 2px;
      padding: 2px 2px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      
      & + .detail-tag {
        margin-left: 10px;
      }
    }

 
    </style>
